import { createContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            setUser(user);
            setLoading(false);
            if (user) {
                try {
                    const docRef = doc(db, 'UserInformation', user.uid);
                    const docSnap = await getDoc(docRef); 
                    if (docSnap.exists()) {
                        setUserInfo(docSnap.data());
                    }
                } catch (error) {
                  console.error("Failed to fetch user info:", error); 
                }
            } else {
                setUserInfo(null); 
            }
        });

        return () => unsubscribe();
    }, []);

    return (
        <UserContext.Provider value={{ user, loading, userInfo, setUserInfo }}>
            {!loading && children}
        </UserContext.Provider>
    );
};
